<ng-container>
  <header class="stepper-header mb-5">
    <div class="text-end d-flex justify-content-between container-lg px-8">
      <h5 *ngIf="title">{{ title | msg | async }}</h5>
      <h5>
        {{ "stepper.step" | msg | async }}: {{ selectedIndex + 1 }}/{{
        steps.length
        }}
      </h5>
    </div>
  </header>

  <div class="container-lg px-8">
    <ng-container [ngTemplateOutlet]="selected!.content"></ng-container>
  </div>

  <footer class="container-lg px-8 text-center text-lg-end">
    <button class="btn btn-primary m-2 px-4" (click)="onPrevious()" [disabled]="isLoading">
      <svg-icon class="icon-arrow" [src]="'../../../assets/images/icons/arrow-left.svg'"></svg-icon>
    </button>
    <button *ngIf="!isLastStep()" class="btn btn-danger m-2 px-4" (click)="onNext()">
      <svg-icon class="icon-arrow" [src]="'../../../assets/images/icons/arrow-right.svg'"></svg-icon>
    </button>
    <button *ngIf="isLastStep()" class="btn btn-danger m-2 px-4" (click)="onSubmit()" [disabled]="isLoading">
      {{ "stepper.buttons.submit" | msg | async }}
    </button>
  </footer>
</ng-container>